import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    children: ReactNode;
    sidePadding?: boolean;
}

const FlowInfotextBetween = ({ children, sidePadding = false }: Props) => (
    <div
        className={twMerge(
            'py-2 text-sm text-gray-800',
            sidePadding ? 'px-2' : '',
        )}
    >
        {children}
    </div>
);

export default FlowInfotextBetween;
